// extracted by mini-css-extract-plugin
export default {"cls1":"InD8OcP1_VHzm_ayGCvl","cls2":"Uu8Kgb9lSbMzMhRIfbxn InD8OcP1_VHzm_ayGCvl"};